<template>
    <div class="wrapper">
        <!-- <div class="bg-img bg1">
            <img class="bg-img-1" :src="bg_img_1" alt />
        </div> -->
        <nav-header-pc v-if="browser_size != 'small'"></nav-header-pc>
        <section class="content mq">
            <div class="inner-box">
                <img
                    class="bg-img-2 bg-pc"
                    v-if="browser_size != 'small'"
                    :src="bg_img_2"
                    alt
                />
                <div class="inner2-box">
                    <div class="sec-1">
                        <h1>
                            {{ $t("Index.text1") }}
                            <br v-if="browser_size == 'small'" />{{ $t("Index.text2") }}
                        </h1>
                    </div>
                    <div class="sec-2">
                        <span class="purple">{{$t('Index.text3')}}</span>
                        <div class="line-row"></div>
                        {{$t('Index.text4')}}
                        <!-- <div class="line-row"></div>连接创作者与粉丝的会员制平台 -->
                    </div>
                    <!-- <h2 class="sec-3">无论你在创作什么，都可以在这里建立自己的会员社群，获得持续的资金支持，让创作从此更自由</h2> -->
                    <h2 class="sec-3">
                      {{$t('Index.text5')}}
                    </h2>
                    <div class="sec-4">
                        <router-link :to="session_user ? `/explore` : { name: 'reg' }">
                            <btn class="size48 w_160">{{$t('Index.text6')}}<i class='ml8 afd afd-zap'></i></btn>
                        </router-link>
                        <btn v-if="!session_user || !is_creator" class="size48 w_160 look3 ml24" @click.native="jump">{{$t('Index.text43')}}</btn>
                        <img
                            class="bg-img-2 bg-m"
                            v-if="browser_size == 'small'"
                            :src="bg_img_2"
                            alt
                        />
                    </div>
                </div>
            </div>
        </section>
        <section class="text-center fwb mt48 fs-40-22 mq mb32">
          <span class="purple">{{$t('Index.text7')}}</span>
        </section>
        <section class="flex-box flex-center flex-wrap relative category-box" style="z-index: 2;">
            <btn v-for="(item, i) in type_list" :key="i"
                @click.native="tap(item.category_id)"
                :class="[category_id == item.category_id ? 'look3' : 'look1']"
                class="fs16 mr24 circle mq pt-12-8 pb-12-8 pr-64-24 pl-64-24 mt-16-8">
                {{item.name}}
            </btn>
        </section>
        <section class="sec-box sec-avatar mt-32-24 mq">
            <!-- <template v-if="category_id == 'rec'">
                <avatar-welcome-card
                    v-for="(user, i) in welcome_user_list"
                    :user="user"
                    :key="i"
                ></avatar-welcome-card>
            </template> -->
            <template v-if="category_id != 'rec'">
                <div v-for="user in welcome_user_list" class="item-box"
                    :key="user.user_id"
                    @click="$mixin_router_push(user.url_slug ? `/a/${user.url_slug}`: `/u/${user.user_id}`)">
                    <avatar-business-card
                        :user="user"
                        :is_no_href="true"
                    ></avatar-business-card>
                </div>
            </template>
        </section>
        <div
            class="flex-box flex-center mt-48-32 mq mb24 relative"
            style="z-index: 2;"
        >
            <router-link to="/explore">
                <btn class="size48 look3">{{$t('Index.text8')}}</btn>
            </router-link>
        </div>
        <section class="sec-box">
            <div class="inner-box">
                <div class="inner2-box desc-box">
                    <div class="pic-box pic-box-0">
                        <pic
                            width="600"
                            height="304"
                            :is_show_origin="true"
                            :src="`${this.GL.PIC_HOST}/static/img/landingpage_membership.png`"
                        ></pic>
                    </div>
                    <div class="tit-box">
                        <h2 class="fs32">{{$t('Index.text9')}}</h2>
                        <div class="mt-16-8 mq desc lh1_6">
                          {{$t('Index.text10')}}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="sec-box">
            <div class="inner-box">
                <div class="inner2-box desc-box">
                    <div class="tit-box">
                        <h2 class="fs32">{{$t('Index.text11')}}</h2>
                        <div class="mt-16-8 mq desc lh1_6">
                            {{$t('Index.text12')}}
                            <br />{{$t('Index.text13')}}
                        </div>
                    </div>
                    <div class="pic-box pic-box-1">
                        <pic
                            width="600"
                            height="310"
                            :is_show_origin="true"
                            :src="`${this.GL.PIC_HOST}/static/img/landingpage_content.png`"
                        ></pic>
                    </div>
                </div>
            </div>
        </section>
        <section class="sec-box">
            <div class="inner-box">
                <div class="inner2-box desc-box">
                    <div class="pic-box pic-box-2">
                        <pic
                            width="600"
                            height="293"
                            :is_show_origin="true"
                            :src="`${this.GL.PIC_HOST}/static/img/landingpage_connection.png`"
                        ></pic>
                    </div>
                    <div class="tit-box">
                        <h2 class="fs32">{{$t('Index.text14')}}</h2>
                        <div class="mt-16-8 mq desc lh1_6">
                            {{$t('Index.text15')}}
                            <br />{{$t('Index.text16')}}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="sec-box">
            <div class="inner-box">
                <div class="inner2-box desc-box">
                    <div class="tit-box">
                        <h2 class="fs32">{{$t('Index.text17')}}</h2>
                        <div class="mt-16-8 mq desc lh1_6">
                          {{$t('Index.text18')}}
                        </div>
                    </div>
                    <div class="pic-box pic-box-3">
                        <pic
                            width="464"
                            height="342"
                            :is_show_origin="true"
                            :src="`${this.GL.PIC_HOST}/static/img/landingpage_fee.png`"
                        ></pic>
                    </div>
                </div>
            </div>
        </section>
        <section class="sec-box info-box">
            <div class="info-bg"></div>
            <div class="inner-box">
                <div class="inner2-box">
                    <h2 class="fs-40-32 mq black-8 text-center">{{$t('Index.text19')}}<br v-if="browser_size == 'small'" />{{$t('Index.text20')}}</h2>
                    <div class="info-item-box">
                        <div class="info-item">
                            <div class="img-box flex-box flex-center">
                                <pic width="260" height="263" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_shop.png`"></pic>
                            </div>
                            <div class="tit text-center black-8 fs28 lh1 fwb">{{$t('Index.text21')}}</div>
                            <div class="text-center black-8 fs16 lh1_6">{{$t('Index.text22')}}<br />{{$t('Index.text23')}}</div>
                        </div>
                        <div class="info-item">
                            <div class="img-box flex-box flex-center">
                                <pic width="260" height="263" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_crowdfunding.png`"></pic>
                            </div>
                            <div class="tit text-center black-8 fs28 lh1 fwb">{{$t('Index.text24')}}</div>
                            <div class="text-center black-8 fs16 lh1_6">{{$t('Index.text25')}}<br />{{$t('Index.text26')}}</div>
                        </div>
                        <div class="info-item">
                            <div class="img-box flex-box flex-center">
                                <pic width="260" height="263" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_album.png`"></pic>
                            </div>
                            <div class="tit text-center black-8 fs28 lh1 fwb">{{$t('Index.text27')}}</div>
                            <div class="text-center black-8 fs16 lh1_6">{{$t('Index.text28')}}<br />{{$t('Index.text29')}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="inner-box">
                <div class="inner2-box step-box">
                    <h2 class="fs-40-32 mq  black-8 text-center">{{$t('Index.text30')}}<br v-if="browser_size == 'small'" />{{$t('Index.text31')}}</h2>
                    <div class="step-item-box">
                        <div class="step-img-box">
                            <pic width="64" height="64" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_step1.png`"></pic>
                        </div>
                        <div>
                            <div class="black-8 fs24 fwb step-tit">{{$t('Index.text32')}}</div>
                            <div class="black-8 fs14 desc lh1_6">{{$t('Index.text33')}}<br v-if="browser_size == 'small'" />{{$t('Index.text34')}}</div>
                        </div>
                    </div>
                    <div class="step-item-box">
                        <div class="step-img-box">
                            <pic width="64" height="64" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_step2.png`"></pic>
                        </div>
                        <div>
                            <div class="black-8 fs24 fwb step-tit">{{$t('Index.text35')}}</div>
                            <div class="black-8 fs14 desc lh1_6">{{$t('Index.text36')}}<br v-if="browser_size == 'small'" />{{$t('Index.text37')}}</div>
                        </div>
                    </div>
                    <div class="step-item-box">
                        <div class="step-img-box">
                            <pic width="64" height="64" :is_show_origin="true" :src="`${GL.PIC_HOST}/static/img/landingpage_step3.png`"></pic>
                        </div>
                        <div>
                            <div class="black-8 fs24 fwb step-tit">{{$t('Index.text38')}}</div>
                            <ul class="black-8 fs14 desc desc-item  lh1_6" style="margin-left:20px;">
                                <li>{{$t('Index.text39')}}</li>
                                <li>{{$t('Index.text40')}}</li>
                                <li>{{$t('Index.text41')}}</li>
                                <li>{{$t('Index.text42')}}</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- <section class="sec-box intro-box">
            <div class="inner-box">
                <div class="inner3-box article-content">
                    <h2 class="text-center fs32">
                        如何
                        <span class="purple">开始</span>爱发电
                    </h2>
                    <div class="mt-60-120 mq relative">
                        <div class="num">1</div>
                        <h3 class="fs24 purple">成为爱发电的创作者</h3>
                        <p class="mt24">
                            爱发电是连接创作者与粉丝的会员制平台。无论你在创作什么，都可以在这里建立自己的会员社区，获得持续的资金支持，让创作从此更自由。
                        </p>
                        <p class="mt24">
                            注册后点击申请成为创作者，装扮你的个人主页，并设置会员发电方案。
                        </p>
                    </div>
                    <div class="mt-60-120 mq relative">
                        <div class="num">2</div>
                        <h3 class="fs24 purple">向粉丝宣传你的爱发电主页</h3>
                        <ul class="mt24 pl16">
                            <li>在社交网站加上你的「爱发电」主页链接。</li>
                            <li>
                                在社交网站发布一条动态，告诉大家你建立了「爱发电」主页，让大家赞助你。（例如微博、微信公众号、豆瓣、知乎等）
                            </li>
                            <li>
                                在你的粉丝群发布含有你的「爱发电」主页链接的公告。
                            </li>
                            <li>
                                在你接下来发布的创作中附上你的「爱发电」主页链接。
                            </li>
                            <li>不要忘了感谢（赞助）你的粉丝！</li>
                        </ul>
                    </div>
                    <div class="mt-60-120 mq relative">
                        <div class="num">3</div>
                        <h3 class="fs24 purple">在爱发电发布内容，持续经营</h3>
                        <p class="mt24">
                            你可以在爱发电发布公开的动态，吸引更多人浏览你的主页。你也可以发布赞助者才可见的动态，提供专属的内容回馈赞助的粉丝。
                        </p>
                        <p class="mt24">
                            和你的创作生涯一样，经营「爱发电」主页也是一个长期的过程。
                        </p>
                    </div>
                </div>
            </div>
        </section> -->
        <section class="footer-btn">
            <div class="inner-box">
                <img
                    class="bg-img-2 bg-pc"
                    v-if="browser_size != 'small'"
                    :src="bg_img_2"
                    alt
                />
                <div class="inner2-box">
                    <div class="sec-4" style="padding-bottom:56px;">
                        <div class="btn-box">
                            <router-link :to="session_user ? `/explore` : { name: 'reg' }">
                              <btn  class="size48 w_160">{{$t('Index.text44')}}<i class='ml8 afd afd-zap'></i></btn>
                            </router-link>
                            <btn v-if="!session_user || !is_creator"  class="size48 w_160 look3 ml24" @click.native="jump">{{$t('Index.text43')}}</btn>
                        </div>
                    </div>
                    <div class="sec-4">
                      <div v-if="browser_size == 'small'" @click="open_lang" class="flex-box black-5 flex-a-center"><i class="mr8 afd afd-earth"></i>{{$t('Index.text45')}}<i class="ml8 afd afd-arrow-down"></i></div>
                    </div>
                </div>
            </div>
        </section>
        <footer-custom v-if="browser_size != 'small'"></footer-custom>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { GET_WELCOME_CATEGORY_LIST, GET_WELCOME_CATEGORY_CREATOR } from "../api/config";

export default {
    name: "index",
    metaInfo() {
        return {
            title: "爱发电 · 连接创作者与粉丝的会员制平台",
            meta: [
                {
                    name: "keywords",
                    content:
                        "爱发电，订阅，创作者，赞助，粉丝，视频，文章，小说，音乐，绘画，动漫，摄影，游戏，艺术，Patreon，主播，Vtuber，播客",
                },
                {
                    name: "description",
                    content:
                        "将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。",
                },
            ],
        };
    },
    inject:['app_action_sheet'],
    data() {
        return {
            name: "",
            type_list:[],
            // category_id:'rec',
            category_id:'5378451a30dd11e8bd4f52540025c377',
            welcome_user_list: [],
        };
    },
    computed: {
        ...mapState("app", ["session_user", "browser_size"]),
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
        // bg_img_1() {
        //     if (this.browser_size == "") {
        //         return "";
        //     }
        //     return this.browser_size == "small"
        //         ? `${this.GL.PIC_HOST}/static/img/bg-lines-mobile@2x.png`
        //         : `${this.GL.PIC_HOST}/static/img/bg-lines@2x.png`;
        // },
        bg_img_2() {
            if (this.browser_size == "") {
                return "";
            }
            return this.browser_size == "small"
                ? `${this.GL.PIC_HOST}/static/img/electriclove-mobile@2x.png`
                : `${this.GL.PIC_HOST}/static/img/electriclove@2x.png`;
        },
        share_config(){
           return {
                url: window.location.href,
                source: `${location.origin}`,
                title: `爱发电 · 连接创作者与粉丝的会员制平台`,
                description: `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`,
                pic: `https://static.afdiancdn.com/static/img/logo/logo.png`,
            };
        },
    },
    watch: {
        category_id(newValue, oldValue){
            if(oldValue == 'rec'){
                this.welcome_user_list = [];
            }

            this.get_users()
        }
    },
    beforeMount() {
        // this.$http
        //     .$axios_all([
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "82bcc94e3e3f11e8a95152540025c377",
        //         }), //https://afdian.net/a/deincosmos
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "58a5518a5a5a11e8868952540025c377",
        //         }), //https://afdian.net/a/projectk4
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "a3900d6239b611e8834052540025c377",
        //         }), //https://afdian.net/a/LDART
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "5f652726ebc111e9b02552540025c377",
        //         }), //https://afdian.net/a/loudmurmurs
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "19620d58416c11e8a7a252540025c377",
        //         }), //https://afdian.net/a/LKsss
        //         this.$http.$axios(GET_USER_PROFILE, {
        //             user_id: "85883d948f3711e9993552540025c377",
        //         }), //https://afdian.net/a/tangdailiyuefuyuanzu
        //     ])
        //     .then(
        //         axios.spread((data1, data2, data3, data4, data5, data6) => {
        //             data1.data.user.rec_text =
        //                 "“爱发电，和我一样都带了‘电’字，而电的存在正是将从无到有实现的魔法力量。将大家的心意凝聚在一起，就成为了‘奇迹’。”";
        //             data2.data.user.rec_text =
        //                 "“借助爱发电公开透明的平台，我们得到了粉丝的大力支持。我们惊喜地发现粉丝的热情远超我们想象，希望以后能通过这个平台与大家近距离交流。”";
        //             data3.data.user.rec_text =
        //                 "“每一个创作者都难免在职业生涯中遇到低谷，而这时每一位支持者投入的实际经济支持，无论在心灵上还是物质上都是一剂强心剂，感谢爱发电提供了这样一个平台。”";
        //             data4.data.user.rec_text =
        //                 "“爱发电平台提供了创作者与其粉丝建立深度联系的机会，这份情感是独一无二的。愿能与爱发电平台共同成长。”";
        //             data5.data.user.rec_text =
        //                 "“爱发电既提供了观众支持喜欢UP主的机会，更赋予了创作者潜心产出的底气和信心。在这种良性循环下，希望每一位创作者都能登堂入室，把自己的理想化作现实。”";
        //             data6.data.user.rec_text =
        //                 "“希望能同爱发电平台、以及喜欢我们的人们一起，把优质的文化传承并延续。”";

        //             data1.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/deincosmos.jpg`;
        //             data2.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/projectk4.jpg`;
        //             data3.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/ldart.jpg`;
        //             data4.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/01-loudmurmurs.jpeg`;
        //             data5.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/02-lks.jpeg`;
        //             data6.data.user.rec_img = `${this.GL.PIC_HOST}/static/img/welcome/tangmusic.jpeg`;

        //             this.welcome_user_list.push(data4.data.user);
        //             this.welcome_user_list.push(data5.data.user);
        //             this.welcome_user_list.push(data6.data.user);
        //             this.welcome_user_list.push(data1.data.user);
        //             this.welcome_user_list.push(data2.data.user);
        //             this.welcome_user_list.push(data3.data.user);
        //         })
        //     );
    },
    async mounted() {
        await this.init();
        this.get_users()
        this.$mixin_share(this.share_config)
    },
    methods: {
        tap(category_id){
            this.category_id = category_id
        },
        async init(){
            if(this.$http.is_run(GET_WELCOME_CATEGORY_LIST)){
                return false
            }
            let data = await this.$http.$axios(GET_WELCOME_CATEGORY_LIST)

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
                return false
            }
            this.type_list = data.data.list

        },
        async get_users(){
            if(this.$http.is_run(GET_WELCOME_CATEGORY_CREATOR)){
                return false
            }
            let data = await this.$http.$axios(GET_WELCOME_CATEGORY_CREATOR,{
                category_id:this.category_id
            })

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
                return false
            }
            this.welcome_user_list = data.data.list

        },
        jump(){
            if(!this.session_user || !this.is_creator){
                this.$store.commit('app/set:redirect_url', '/apply');
                this.$router.push('/reg')
            }
            if(this.session_user){
                this.$router.push('/apply')
            }
        },
        open_lang(){
          this.app_action_sheet('open', {
            component:'action-lang',
            // target:e.target
          })
        }
    },
};
</script>
<style lang="stylus" scoped>
.wrapper{
  background: $white;
  .vm-nav-header-pc /deep/{
    background: $white;

    .inner-box {
      border: 0;
    }
  }
  .vm-btn {
      &.look1{
          &:hover {
            color: $purple;
            background: $purple-1;
        }
      }
      &.look3{
          &:hover {
            background: $purple-1;
        }
      }
  }

  .line-row {
    width: 1px;
    height: px2rem(20);
    margin: 0 px2rem(16);
    background: $black-1;
  }

  .bg-img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    background-position: left top;

    .bg-img-1 {
      position: absolute;
      left: 0;
      height: 100%;
      top: 0;
    }

    &.bg1 {
      z-index: 1;
    }

    &.bg2 {
      z-index: 2;
    }
  }

  .bg-pc {
    display: block;
  }

  .bg-m {
    display: hide;
  }

  .bg-white {
    background-color: $white-bg;
  }

  .sec-box {
    height: px2rem(400);
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    justify-content: center;
  }

  // .4-bg {
  //   background: #F7F7F7;
  // }

  .w_160 {
    width: px2rem(160);
  }

  .inner-box {
    width: 100%;
    position: relative;
  }

  .inner2-box {
    max-width: $width-pc;
    margin: 0 auto;
    position: relative;
  }

  .inner3-box {
    max-width: px2rem(640);
    margin: 0 auto;
    position: relative;
  }

  .pic-box-0 {
    width: px2rem(600);
  }

  .pic-box-1 {
    width: px2rem(600);
  }

  .pic-box-2 {
    width: px2rem(600);
  }

  .pic-box-3 {
    width: px2rem(430);
  }

  .tit-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .desc-box {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }

  .footer-btn, .content {
    position: relative;
    height: px2rem(630);
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    width: 100%;
    z-index: 2;
    box-sizing: border-box;
    bottom: 0;

    .bg-img-2 {
      object-fit: cover;
      position: absolute;
      left: 0;
      top: fs2rem(24);
      transform: translateY(-50%);
      z-index: 0;
    }

    .sec-1 {
      display: flex;
      color: $purple;

      h1 {
        font-size: fs2rem(48);
        background: $white;
        line-height: 1;
        padding: 0 px2rem(32);
        margin: 0 _px2rem(32);
      }
    }

    .sec-2 {
      font-size: fs2rem(20);
      line-height: 1;
      margin-top: px2rem(48);
      display: flex;
      align-content: center;
    }

    .sec-3 {
      font-size: fs2rem(14);
      color: $black-5;
      margin-top: px2rem(24);
      font-weight: normal;
    }

    .sec-4 {
      margin-top: px2rem(48);
      display:flex;
    //   justify-content: center;
      align-items: center;
    }
  }

  .footer-btn {
    height: auto;

    .inner2-box {
      max-width: px2rem(640);
    }

    .sec-4 {
      margin: 0;
      padding-bottom: px2rem(120);
    }

    .btn-box {
      padding: 0 px2rem(32);
      background-color: $white;
      display: flex;
    }
  }

  .vm-footer-custom {
    position: relative;
  }

  .intro-box {
    padding: px2rem(160);
    height: auto;
  }

  .num {
    font-size: fs2rem(64);
    line-height: 1;
    color: $black-1;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(-200%);
  }

  .vm-footer-custom {
    z-index: 1;
  }

  .vm-avatar-welcome-card {
    // flex: 1;
    position: relative;
    z-index: 2;
    margin-right: px2rem(32);
    margin-bottom: px2rem(32);
    width: 31%;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .sec-avatar {
    display: flex;
    position: relative;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    max-width: $width-pc;
    margin: px2rem(64) auto 0;
  }

  .item-box {
        width: 32%;
        padding: 16px;
        box-sizing: border-box;
        margin-bottom: 16px;

        &:hover {
            // background $black-03
            .vm-avatar-business-card /deep/{
                border: 1px solid $purple;
            }
        }

        &:nth-child(2n + 1) {
            // margin-left _px2rem(16)
        }

        &:nth-child(2n) {
            // margin-left px2rem(16)
        }

        .vm-avatar-business-card /deep/{
            border: 1px solid transparent;
        }
    }
    .category-box{
        width:$width-pc;
        margin:0 auto;
    }
    .info-box{
        position:relative;
        height:auto;
        padding-top:80px;
        padding-bottom:140px;
        margin-top:8px;
        .info-bg{
            background:$purple-05;
            position: absolute;
            left:0;
            right:0;
            top:0;
            bottom:430px;
        }
        .info-item-box{
            margin-top:80px;
            display:flex;
            justify-content: space-between;
        }
        .info-item{
            width:260px;
        }
        .tit{
            margin-top:24px;
            margin-bottom:24px;
        }
        .step-tit{
            margin-top:24px;
            margin-bottom:24px;
        }
        .img-box{
            // display:block;
            height:263px;
            img{
                height:100%;
                width:auto;
            }
        }
    }
    .step-box{
        margin-top:126px;
        padding:80px 84px;
        box-sizing: border-box;
        border-radius:25px;
        background:$white;
        box-shadow:0 8px 64px 0 $purple-1;
        .step-item-box{
            margin-top:48px;
            display:flex;
            &:first-child{
                margin-top:68px;
            }
        }
        .step-img-box{
            margin-right:24px;
            height:64px;
            width:64px;
        }
        .tit{
            margin-top:16px;
        }
        .desc{
            margin-top:24px;
        }
    }

  @media (max-width: $width-mobile) {
    // .footer-btn {

    // }
    .sec-4 {
        // display: flex;
        justify-content: center;
    }
    .category-box{
        width:100%;
    }
    .item-box {
        width: 100%;
        padding: 0;
        margin-bottom: px2rem(48);

        &:hover {
            background: transparent;
        }

        &:nth-child(2n + 1), &:nth-child(2n) {
            margin-left: 0;
        }
    }

    .num {
      font-size: fs2rem(48);
      line-height: 1;
      left: 50%;
      top: 0;
      transform: translate(-50%, -110%);
    }

    .intro-box {
      padding: px2rem(120) px2rem(24) !important;

      h3 {
        text-align: center;
      }
    }

    .bg-pc {
      display: hide;
    }

    .bg-m {
      display: block;
    }

    .desc-box {
      flex-direction: column;
    }

    .sec-box {
      height: auto;
      padding: px2rem(50) px2rem(8);
    }

    .pic-box {
      order: 1;
    }

    .tit-box {
      margin-top: px2rem(40);
      order: 2;
      align-items: center;

      .desc {
        text-align: center;
      }
    }

    .pic-box-0, .pic-box-1, .pic-box-2, .pic-box-3 {
      width: 100%;
    }

    .content {
      top: 0;
      padding-top: px2rem(90);
      text-align: center;
      overflow: hidden;
      justify-content: flex-start;
      height: calc(100vh - 100px);

      .bg-img-2 {
        left: 50%;
        bottom: 0;
        position: absolute;
        top: auto;
        transform: translate(-50%, 110%);
        width: 20%;
      }

      .sec-1 {
        justify-content: center;
        padding: 0 px2rem(60);

        h1 {
          font-size: fs2rem(32);
          line-height: inherit;
        }
      }

      .sec-2 {
        font-size: fs2rem(16);
        margin-top: px2rem(24);
        padding: 0 px2rem(10);
        justify-content: center;
      }

      .sec-3 {
        margin-top: px2rem(8);
        padding: 0 px2rem(20);
        line-height: inherit;
      }

      .sec-4 {
        margin-top: px2rem(24);
      }
    }

    .vm-avatar-welcome-card {
      margin-top: px2rem(24);
      margin-right: 0;
      width: 100%;
    }

    .sec-avatar {
      flex-direction: column;
      padding: 0 px2rem(16);
      margin-top: 0;
    }
    .info-box{
        margin-top:0px;
        .info-item-box{
            margin-top:0px;
            display:block;
        }
        .info-item{
            margin-top:64px;
            width:100%;
        }
        .tit{
            margin-top:16px;
            margin-bottom:16px;
        }
        .step-tit{
            margin-top:8px;
            margin-bottom:16px;
        }
        .info-bg{
            bottom:315px;
        }
    }
    .step-box{
        width:90vw;
        box-sizing:border-box;
        padding:64px 0px;
        display:flex;
        flex-direction: column;
        text-align:center;
        .step-item-box{
            margin-top:64px;
            display:block;
            &:first-child{
                margin-top:48px;
            }
        }
        .step-img-box{
            margin:0 auto;
        }
        .desc-item{
            text-align:left;
            padding:0 16px;
        }
    }
  }


  @media (min-width: $width-mobile + 1) and (max-width: $width-pc) {
    .content {
      padding: 0 px2rem(80);

      .bg-img-2 {
        top: fs2rem(16);
        transform: translateY(-50%);
      }

      .sec-1 {
        h1 {
          font-size: fs2rem(32);
        }
      }

      .sec-2 {
        margin-top: px2rem(24);
      }

      .sec-3 {
      }
    }
  }
}
</style>
